module.exports = __webpack_public_path__ + "static/img/9.9ad6951.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/9.png
// module id = b8CE
// module chunks = 0